import React from 'react';
import { Flex, Text } from '@spothero/ui';
export const ReviewPromptsList = ({ prompts }) => {
    if (!prompts || prompts.length === 0) {
        return null;
    }
    return (<Flex flexWrap="wrap" gap={3} marginTop={2} data-testid="ReviewPromptsList">
            {prompts.map(prompt => (<Flex key={prompt.id} alignItems="center" gap={1} paddingX={2} paddingY={0.5} bg="gray.50" borderRadius="md">
                    <Text>{prompt.emoji}</Text>
                    <Text fontSize="xs">{prompt.prompt_text}</Text>
                </Flex>))}
        </Flex>);
};
